import { MixPanelType } from '../../models/MixPanel'
import {
  SugestaoDeUnidadesElegibilidade,
  UnidadeEndereco
} from '../../models/Unidade'
import { FallbackName } from '../../pages/Consulta/FallBacks'
import { ValidacaoElegibilidade } from './elegibilidadeHelper'
import { gerarLinkDoMaps } from './googleMapsHelper'

/**
 * Obtem endereço da Unidade formatado
 * @param enderecoUnidade Endereço da Unidade
 * @param exibirComplemento Exibir ou não informação do complemento
 */
export const obtemEnderecoCompleto = (
  enderecoUnidade: UnidadeEndereco,
  exibirComplemento = true
): string => {
  const {
    logradouro,
    complemento,
    numero,
    bairro,
    municipio,
    uf
  } = enderecoUnidade

  const endereco = {
    _logradouro: logradouro,
    _numero: numero,
    _complemento: complemento,
    _bairro: bairro,
    _municipio: municipio,
    _uf: uf,
    get logradouro() {
      return this._logradouro ? this._logradouro : ''
    },
    get numero() {
      return this._numero ? `, ${this._numero}` : ''
    },
    get complemento() {
      return this._complemento && exibirComplemento
        ? `, ${this._complemento}`
        : ''
    },
    get bairro() {
      return this._bairro ? ` - ${this._bairro}` : ''
    },
    get municipio() {
      return this._municipio ? `, ${this._municipio}` : ''
    },
    get uf() {
      return this._uf ? ` - ${this._uf}` : ''
    }
  }

  return `${endereco.logradouro}${endereco.numero}${endereco.complemento}${endereco.bairro}${endereco.municipio}${endereco.uf}`
}

export const obtemLinkDoGoogleMaps = (endereco: UnidadeEndereco): string => {
  const fullAddress = `${obtemEnderecoCompleto(endereco, false)} - ${
    endereco.cep
  }`

  return gerarLinkDoMaps(fullAddress)
}

export const obtemUnidadesValidacao = (
  validacoes: ValidacaoElegibilidade[]
) => {
  if (!validacoes || validacoes.length === 0) return []

  const NOME_VALIDACAO: FallbackName =
    'PlanoComAtendimentoParaEspecialidadeNoLocal'
  const validacao = validacoes.find(
    validacao => validacao.validacao === NOME_VALIDACAO
  )

  return validacao?.unidades
}

export const obtemUnidadesPorCobertura = (
  unidades: SugestaoDeUnidadesElegibilidade[] = []
) => {
  if (!unidades || unidades.length === 0) return

  const unidadesPorCobertura: MixPanelType.VerificarCobertura = {
    CODIGOS_UNIDADES_COM_COBERTURA: [],
    NOMES_UNIDADES_COM_COBERTURA: [],
    CODIGOS_UNIDADES_SEM_COBERTURA: [],
    NOMES_UNIDADES_SEM_COBERTURA: []
  }

  for (const unidade of unidades) {
    if (unidade.possuiCobertura) {
      unidadesPorCobertura.CODIGOS_UNIDADES_COM_COBERTURA?.push(unidade.id)
      unidadesPorCobertura.NOMES_UNIDADES_COM_COBERTURA?.push(unidade.nome)
    } else if (!unidade.possuiCobertura) {
      unidadesPorCobertura.CODIGOS_UNIDADES_SEM_COBERTURA?.push(unidade.id)
      unidadesPorCobertura.NOMES_UNIDADES_SEM_COBERTURA?.push(unidade.nome)
    }
  }

  return unidadesPorCobertura
}
